import type { LoginFormHandler } from '@athena-lib/LoginForm';

type FormEvent = SubmitEvent & {
  currentTarget: EventTarget & HTMLFormElement;
};

type HandlerHelpers = {
  defaultMessage: string;
  onSuccess: (notifications: string[]) => void;
  onError: (errors: string[]) => void;
  reset: () => void;
  guard?: () => boolean;
};

export const required = (label: string) => `${label}*`;

export const handler = (f: LoginFormHandler, helpers: HandlerHelpers) => async (e: FormEvent) => {
  e.preventDefault();
  helpers.reset();

  if (helpers.guard && !helpers.guard()) {
    return;
  }

  try {
    const { success, notifications } = await f(e);

    if (!success) {
      return helpers.onError(notifications);
    }

    if (notifications.length > 0) {
      helpers.onSuccess(notifications);
    }
  } catch {
    helpers.onError([helpers.defaultMessage]);
  }
};
